<template>
<section>
    
    
    <div class="wrap">
        <div class="find_showroom_info" style="margin-top:20px">
            <dl class="showroom_info">
                <dt>
                    {{ shopItem.name }}
                    <div><img :src="shopItem.brand ? shopItem.brand.attUrl : ''"></div>
                </dt>
                <dd>
                    <span>{{ (shopItem.dealer) ? shopItem.dealer.name : '' }}</span>
                    <p style="margin-top:5px">{{ shopItem.addr }}</p>
                </dd>
            </dl>
        </div>

        <div class="showroom_consultant_list_box">
            <div class="title_box">
                <h4 class="title">소속 컨설턴트<span>{{ totalCount }}</span></h4>
                <select class="nojs_select" v-model="selectSort">
                    <option :value="sort.ASC">ㄱ-ㅎ</option>
                    <option :value="sort.DESC">ㅎ-ㄱ</option>
                </select>
            </div>

            <ul class="showroom_consultant">
                <li v-for="(sc, idx) in scItems" :key="idx">
                    <router-link :to="`/scInfo/${sc.id}`">
                        <figure>
                            <img :src="viewScAttUrl(sc.attUrl)">
                        </figure>
                        <figcaption>
                            <div class="name">
                                <dl>
                                    <dt>{{sc.name}} 컨설턴트</dt>
                                    <dd>경력 {{ $_getScCareerByMonth(sc.careerMonth) }}</dd>
                                </dl>
                                <span v-if="sc.certificationYn == 'Y'">
                                    <img :src="resource.imgIconCertified3">인증
                                </span>
                            </div>
                            <div class="social">
                                <span><i class="fas fa-star"></i>{{ sc.good }}</span>
                                <span><i class="fas fa-comment"></i>{{ sc.reviewCount }}</span>
                            </div>
                        </figcaption>
                    </router-link>
                </li>
            </ul>
        </div>
        
    </div>
</section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { InfinityScrollMixin } from '../../mixins/InfinityScrollMixin';

export default {
    name:'ShopSc',
    mixins: [ InfinityScrollMixin ],
    components:{
    },
    data() {
        return {
            selectSort: "ASC",
        }
    },
    computed: {
        ...mapState(["sort", "resource"]),
        ...mapState({
            shopItem: state => state.shop.item,
            scItems: state => state.sc.items,
            totalCount: state => state.sc.totalCount,
        }),
        ...mapGetters(['viewScAttUrl']),
        shopId() {
            return this.$route.params.shopId; 
        }
    },
    watch: {
        selectSort() {
            this.$store.commit('CLEAR_SC_LIST');
            this.changeSearchOption();
        }
    },
    created() {
        
        this.$store.dispatch('GET_SHOP', this.shopId)
        .then(() => { 
            this.$store.commit('SHOW_ONLOAD');
        })
        .catch((e)=>{
            this.$store.commit('SHOW_ONLOAD');
            this.apiCatch(e);
        })
        this.setScroll();
        this.getContentList();
        this.$store.state.headerTitle = ('소속 컨설턴트');
    },
    destroyed() {
        this.removeScroll();
        this.$store.commit('CLEAR_SC_LIST');
    },
    methods: {
        getContentList() {
            if(this.scItems.length < this.totalCount || this.page == 0) {
                this.$store.dispatch(
                    'GET_SC_LIST_PAGE',
                    {
                        shopId: this.shopId,
                        orderby: "name",
                        sort: this.selectSort,
                        page: this.page++,
                        size: this.limit
                    }
                )
                .then(() => {
                    this.scrollPause = false;
                });
            }
            else {
                this.doneFlag = true;
            }
        },
    }

    
}
</script>

<style scoped>

</style>